<div class="ship-details-actions">
    <ul class="actions">
        @if (hasClaim$ | async) {
            <li class="action" (click)="actionClicked('viewClaim')">
                <img class="action-icon"
                     ngSrc="/assets/icons/blue/add_notes.svg"
                     alt="File a Claim"
                     height="28"
                     width="25">
                <span class="action-label">{{ 'shipDetailsActions.viewClaim' | translate }}</span>
            </li>
        } @else if (!shipment?.IsHighValueShipment && !isShipDatePastSixMonths) {
            @let claimsBlockedCountries = environment.production ? ['DE', 'GB', 'FR', 'IT', 'HK'] : [];
            @if (!claimsBlockedCountries.includes(user?.CountryCode?.toUpperCase())) {
                <li class="action" (click)="actionClicked('fileClaim')">
                    <img class="action-icon"
                         ngSrc="/assets/icons/blue/add_notes.svg"
                         alt="File a Claim"
                         height="28"
                         width="25">
                    <span class="action-label">{{ 'shipDetailsActions.fileClaim' | translate }}</span>
                </li>
            }
        }

        <li class="action" *ngIf="showReship" (click)="actionClicked('reship')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/reship.svg"
                 alt="Reship"
                 height="28"
                 width="25">
            <span class="action-label">{{ 'shipDetailsActions.reship' | translate }}</span>
        </li>
        <li class="action" *ngIf="showReprintLabel" (click)="actionClicked('reprintLabel')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/print.svg"
                 alt="Reprint Label"
                 height="28"
                 width="29">
            <span class="action-label">{{ 'shipDetailsActions.reprintLabel' | translate }}</span>
        </li>
        <li class="action" *ngIf="showEmailLabel" (click)="actionClicked('emailLabel')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/email.svg"
                 alt="Email Label"
                 height="28"
                 width="28">
            <span class="action-label">{{ 'shipDetailsActions.emailLabel' | translate }}</span>
        </li>
        <li class="action" *ngIf="showDownloadLabel" (click)="actionClicked('downloadLabel')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/pdf.svg"
                 alt="Download Label"
                 height="28"
                 width="29">
            <span class="action-label">{{ 'shipDetailsActions.downloadLabel' | translate }}</span>
        </li>
        <li class="action" *ngIf="showReprintCommercialInvoice" (click)="actionClicked('reprintCommercialInvoice')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/label.svg"
                 alt="Reprint Commercial Invoice"
                 height="28"
                 width="29">
            <span class="action-label">{{ 'shipDetailsActions.reprintCommercialInvoice' | translate }}</span>
        </li>
        <li class="action" *ngIf="showPrintNAFTAForm" (click)="actionClicked('printNAFTAForm')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/label.svg"
                 alt="Print USMCA Form"
                 height="28"
                 width="29">
            <span class="action-label">{{ 'shipDetailsActions.printNAFTAForm' | translate }}</span>
        </li>
        <li class="action" *ngIf="false" (click)="actionClicked('viewPendingShipments')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/label.svg"
                 alt="View Pending Shipments"
                 height="28"
                 width="29">
            <span class="action-label">{{ 'shipDetailsActions.viewPendingShipments' | translate }}</span>
        </li>
        <li class="action button-container"
            *ngIf="showViewPendingShipments"
            (click)="actionClicked('viewPendingShipments')">
            <button type="button"
                    mat-raised-button
                    class="action-button alternative-button">
                {{ 'shipDetailsActions.viewPendingShipments' | translate }}
            </button>
        </li>
        <li class="action" *ngIf="showPrintShipmentDetails" (click)="actionClicked('printShipmentDetails')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/label.svg"
                 alt="Print Shipment Details"
                 height="28"
                 width="29">
            <span class="action-label">{{ 'shipDetailsActions.printShipmentDetails' | translate }}</span>
        </li>
        <li class="action" *ngIf="showPOD" (click)="actionClicked('downloadPOD')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/pdf.svg"
                 alt="Proof of Delivery"
                 height="28"
                 width="29">
            <span class="action-label">{{ 'shipDetailsActions.proofOfDelivery' | translate }}</span>
        </li>
        <li class="divider"></li>
        <li class="action" *ngIf="isAllowShipmentEdit" (click)="actionClicked('editShipment')">
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/edit.svg"
                 alt="{{ 'editShipment' | translate }}"
                 height="28"
                 width="28">
            <span class="action-label">{{ "shipmentDetails.edit" | translate }}</span>

        <li class="action" *ngIf="showVoidShipment" (click)="actionClicked('voidShipment')">
            <button type="button"
                    mat-raised-button
                    class="action-button alternative-button hide-me">
                {{ 'shipDetailsActions.void' | translate }}
            </button>
            <img class="action-icon"
                 ngSrc="/assets/icons/blue/void.svg"
                 alt="Void Shipment"
                 height="28"
                 width="28">
            <span class="action-label">{{ 'shipDetailsActions.void' | translate }}</span>
        </li>

        @if (shipment?.UseAccessPointCode && !isShipmentVoided && (!hasTrackingScans || !isPackagedPickedUp)) {
            <li class="action">
                <upsc-view-access-code [shipmentId]="shipment?.ShipmentId"></upsc-view-access-code>
            </li>

            <li class="action">
                <upsc-resend-access-code [shipmentId]="shipment?.ShipmentId"></upsc-resend-access-code>
            </li>
        }
    </ul>
</div>
